"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var h = require("./../../utils/createElement").h;
var React = tslib_1.__importStar(require("react"));
var chromatism_1 = require("chromatism");
var theme_1 = require("../../utils/theme");
var interface_1 = require("./interface");
var helper_1 = require("../../utils/helper");
var Eyedropper_1 = tslib_1.__importDefault(require("./Eyedropper"));
var nativeEyedropper_1 = require("./nativeEyedropper");
var Palette = (function (_super) {
    tslib_1.__extends(Palette, _super);
    function Palette() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.initialColor = _this.recieveInitialColor(_this.props.selectedColor);
        _this.state = {
            colorObject: _this.initialColor.initialColorObject,
            alpha: _this.initialColor.initialAlpha,
            hexForShow: _this.initialColor.initialColorObject.hex,
            showEyeDropper: false,
        };
        _this.colorBarRef = React.createRef();
        _this.colorMapRef = React.createRef();
        _this.handleCursorMoveForColorMap = _this.handleCursorMove.bind(_this, interface_1.PaletteCursorTarget.colormap);
        _this.handleCursorMoveForHue = _this.handleCursorMove.bind(_this, interface_1.PaletteCursorTarget.hue);
        _this.handleCursorMoveForAlpha = _this.handleCursorMove.bind(_this, interface_1.PaletteCursorTarget.alpha);
        _this.handleCursorEndForColorMap = _this.handleCursorEnd.bind(_this, interface_1.PaletteCursorTarget.colormap);
        _this.handleCursorEndForHue = _this.handleCursorEnd.bind(_this, interface_1.PaletteCursorTarget.hue);
        _this.handleCursorEndForAlpha = _this.handleCursorEnd.bind(_this, interface_1.PaletteCursorTarget.alpha);
        _this.onColorChange = function (newColorObject, isHexForShowChange) {
            if (isHexForShowChange === void 0) { isHexForShowChange = true; }
            isHexForShowChange ? _this.setState({
                colorObject: newColorObject,
                hexForShow: newColorObject.hex,
                showEyeDropper: false,
            })
                : _this.setState({
                    colorObject: newColorObject,
                    showEyeDropper: false,
                });
        };
        _this.onColorSelect = function (color, alpha) {
            var _a, _b;
            var currentColorObject = color || _this.state.colorObject;
            var _c = currentColorObject.rgb, r = _c.r, g = _c.g, b = _c.b;
            var currentAlpha = alpha || _this.state.alpha;
            var round = Math.round;
            (_b = (_a = _this.props).onColorSelect) === null || _b === void 0 ? void 0 : _b.call(_a, "rgba(" + round(r) + "," + round(g) + "," + round(b) + "," + currentAlpha.toFixed(2) + ")");
        };
        _this.onAlphaChange = function (alpha) {
            _this.setState({
                alpha: alpha,
                showEyeDropper: false,
            });
        };
        _this.calculateColorMapRelativeRatio = function (e) {
            var _a;
            var mapRect = (_a = _this.colorMapRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
            if (!mapRect) {
                return { width: 1, height: 1 };
            }
            var widthRatio = (e.clientX - mapRect.left) / mapRect.width;
            var heightRatio = (mapRect.top + mapRect.height - e.clientY) / mapRect.height;
            return {
                width: widthRatio,
                height: heightRatio,
            };
        };
        _this.calculateColorBarRelativeRaito = function (e) {
            var _a;
            var barRect = (_a = _this.colorBarRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
            if (!barRect) {
                return 1;
            }
            var ratio = (e.clientX - barRect.left) / barRect.width;
            return ratio;
        };
        _this.getRangedValue = function (min, max, number) {
            return Math.max(min, Math.min(number, max));
        };
        _this.calculateColorMapResult = function (relativeRatio) {
            var colorObject = _this.state.colorObject;
            var newSaturation = _this.getRangedValue(0, 100, relativeRatio.width * 100);
            var newValue = _this.getRangedValue(0.1, 100, relativeRatio.height * 100);
            if (newValue === 100) {
                newValue = 99.9;
            }
            return chromatism_1.convert({
                h: colorObject.hsv.h,
                s: newSaturation,
                v: newValue,
            });
        };
        _this.calculateHueBarResult = function (relativeRatio) {
            var colorObject = _this.state.colorObject;
            var newHue = _this.getRangedValue(0, 360, relativeRatio * 360);
            return chromatism_1.convert({
                h: newHue,
                s: colorObject.hsl.s,
                l: colorObject.hsl.l,
            });
        };
        _this.calculateAlphaBarResult = function (relativeRatio) {
            return _this.getRangedValue(0, 1, relativeRatio);
        };
        _this.handleOpenEyeDropper = function (e) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var onEyeDroppperVisibleChange, sRGBHex, error_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!nativeEyedropper_1.supportNativeEyedropper()) return [3, 6];
                        onEyeDroppperVisibleChange = this.props.onEyeDroppperVisibleChange;
                        onEyeDroppperVisibleChange === null || onEyeDroppperVisibleChange === void 0 ? void 0 : onEyeDroppperVisibleChange(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4, nativeEyedropper_1.useNativeEyedropper()];
                    case 2:
                        sRGBHex = (_a.sent()).sRGBHex;
                        this.handleEyedropperSelect(sRGBHex);
                        return [3, 5];
                    case 3:
                        error_1 = _a.sent();
                        return [3, 5];
                    case 4:
                        onEyeDroppperVisibleChange === null || onEyeDroppperVisibleChange === void 0 ? void 0 : onEyeDroppperVisibleChange(false);
                        return [7];
                    case 5: return [2];
                    case 6:
                        this.mousePosition = { clientX: e.clientX, clientY: e.clientY };
                        this.setState({ showEyeDropper: true });
                        return [2];
                }
            });
        }); };
        _this.handleCurosrDown = function (e, target) {
            e.stopPropagation();
            switch (target) {
                case interface_1.PaletteCursorTarget.colormap:
                    document.addEventListener('mousemove', _this.handleCursorMoveForColorMap);
                    document.addEventListener('mouseup', _this.handleCursorEndForColorMap);
                    break;
                case interface_1.PaletteCursorTarget.hue:
                    document.addEventListener('mousemove', _this.handleCursorMoveForHue);
                    document.addEventListener('mouseup', _this.handleCursorEndForHue);
                    break;
                case interface_1.PaletteCursorTarget.alpha:
                    document.addEventListener('mousemove', _this.handleCursorMoveForAlpha);
                    document.addEventListener('mouseup', _this.handleCursorEndForAlpha);
                    break;
            }
        };
        _this.handleRGBInput = function (r, g, b) {
            if (r === void 0) { r = _this.state.colorObject.rgb.r; }
            if (g === void 0) { g = _this.state.colorObject.rgb.g; }
            if (b === void 0) { b = _this.state.colorObject.rgb.b; }
            var newColor = chromatism_1.convert({ r: r, g: g, b: b });
            _this.onColorChange(newColor);
            _this.onColorSelect(newColor);
        };
        _this.handleAlphaInput = function (alpha) {
            var correctAlphaNumber = _this.correctNumberInput(alpha, 0, 100);
            var newAlpha = correctAlphaNumber / 100;
            _this.onAlphaChange(newAlpha);
            _this.onColorSelect(undefined, newAlpha);
        };
        _this.handleHexInput = function (hex) {
            _this.setState({ hexForShow: hex });
            if (/^#([0-9A-F]{3}){1,2}$/i.test("#" + hex)) {
                var newHex = hex.length === 3 ?
                    hex.replace(/([0-9A-F])([0-9A-F])([0-9A-F])/i, '$1$1$2$2$3$3')
                    : hex;
                newHex = "#" + newHex;
                var newColor = chromatism_1.convert(newHex);
                _this.onColorChange(newColor, false);
                _this.onColorSelect(newColor);
            }
        };
        _this.handleEyedropperSelect = function (color) {
            var colorObject = chromatism_1.convert(color);
            _this.onColorChange(colorObject);
            _this.onColorSelect(colorObject, 1);
        };
        _this.renderColorMap = function (classNames) {
            var prefixCls = _this.props.prefixCls;
            var colorObject = _this.state.colorObject;
            var colorMapCls = classNames(prefixCls + "-colormap");
            var colorMapBackCls = classNames(prefixCls + "-colormap-back");
            var colorMapTrackCls = classNames(prefixCls + "-colormap-track");
            var colorMapBackCursor = classNames(prefixCls + "-colormap-cursor");
            var basedMaskColor = chromatism_1.convert({ h: colorObject.hsv.h, s: 100, v: 100 });
            return (h("div", { className: colorMapCls, style: { background: basedMaskColor.hex } },
                h("div", { className: colorMapTrackCls },
                    h("div", { className: colorMapBackCursor, style: {
                            left: colorObject.hsv.s + "%",
                            top: 100 - colorObject.hsv.v + "%",
                            background: colorObject.hex,
                        } })),
                h("div", { className: colorMapBackCls, ref: _this.colorMapRef, onMouseDown: function (e) { return _this.handleCurosrDown(e, interface_1.PaletteCursorTarget.colormap); } })));
        };
        _this.renderEyeDropper = function (classNames, parentClassName) {
            var _a = _this.props, eyeDropperDisabled = _a.eyeDropperDisabled, eyeDroppperContainer = _a.eyeDroppperContainer, onEyeDroppperVisibleChange = _a.onEyeDroppperVisibleChange, prefixCls = _a.prefixCls;
            var showEyeDropper = _this.state.showEyeDropper;
            var strawCls = classNames(parentClassName + "-straw");
            return (!eyeDropperDisabled
                && (h("div", { className: strawCls, onClick: _this.handleOpenEyeDropper }, !nativeEyedropper_1.supportNativeEyedropper() && h(Eyedropper_1.default, { prefixCls: prefixCls, containerDom: eyeDroppperContainer, visible: showEyeDropper, initialPosition: _this.mousePosition, onVisibleChange: onEyeDroppperVisibleChange, onColorChange: _this.handleEyedropperSelect }))));
        };
        _this.renderHueBar = function (classNames, parentClassName) {
            var colorObject = _this.state.colorObject;
            var hueBarCls = classNames(parentClassName + "-hue");
            var colorBarCls = classNames(hueBarCls + "-bar");
            var hueSlider = classNames(parentClassName + "-slider");
            var hueSliderTrack = classNames(parentClassName + "-track");
            var hueSliderColor = chromatism_1.convert({ h: colorObject.hsv.h, s: 100, v: 100 });
            var hueSliderPosition = (hueSliderColor.hsv.h / 360) * 100;
            return (h("div", { className: hueBarCls, onMouseDown: function (e) { return _this.handleCurosrDown(e, interface_1.PaletteCursorTarget.hue); } },
                h("div", { className: hueSliderTrack },
                    h("div", { className: hueSlider, style: { left: hueSliderPosition + "%", background: hueSliderColor.hex } })),
                h("div", { className: colorBarCls })));
        };
        _this.renderAlphaBar = function (classNames, parentClassName) {
            var _a = _this.state, colorObject = _a.colorObject, alpha = _a.alpha;
            var alphaBarCls = classNames(parentClassName + "-alpha");
            var colorBarCls = classNames(alphaBarCls + "-bar");
            var alphaSlider = classNames(parentClassName + "-slider");
            var alphaSliderTrack = classNames(parentClassName + "-track");
            var alphaBarColor = chromatism_1.convert({ h: colorObject.hsv.h, s: 100, v: 100 });
            return (h("div", { className: alphaBarCls, onMouseDown: function (e) { return _this.handleCurosrDown(e, interface_1.PaletteCursorTarget.alpha); } },
                h("div", { className: alphaSliderTrack },
                    h("div", { className: alphaSlider, style: { left: alpha * 100 + "%", background: alphaBarColor.hex } })),
                h("div", { className: colorBarCls, style: { background: "linear-gradient(to right, transparent 0%, " + alphaBarColor.hex + " 100%)" } })));
        };
        _this.renderPreview = function (classNames, parentClassName) {
            var _a = _this.state, colorObject = _a.colorObject, alpha = _a.alpha;
            var previewCls = classNames(parentClassName + "-preview");
            var previewColor = classNames(previewCls + "-color");
            return (h("div", { className: previewCls },
                h("div", { className: previewColor, style: { background: colorObject.hex, opacity: alpha } })));
        };
        _this.renderColorInput = function (props) {
            var classNames = props.classNames, parentClassName = props.parentClassName, cellName = props.cellName, value = props.value, onChange = props.onChange;
            var inputCellCls = classNames(parentClassName + "-" + cellName);
            var inputBoxCls = classNames(parentClassName + "-box");
            var inputLabelCls = classNames(parentClassName + "-label");
            return (h("div", { className: inputCellCls },
                h("input", { className: inputBoxCls, spellCheck: false, value: value.toString(), onChange: function (e) { return onChange(e.target.value); }, onMouseDown: function (e) { return e.stopPropagation(); } }),
                h("span", { className: inputLabelCls }, cellName)));
        };
        _this.themedRender = function (classNames) {
            var _a = _this.props, prefixCls = _a.prefixCls, className = _a.className, style = _a.style, children = _a.children, eyeDropperDisabled = _a.eyeDropperDisabled, eyeDroppperContainer = _a.eyeDroppperContainer, selectedColor = _a.selectedColor, onColorSelect = _a.onColorSelect, rest = tslib_1.__rest(_a, ["prefixCls", "className", "style", "children", "eyeDropperDisabled", "eyeDroppperContainer", "selectedColor", "onColorSelect"]);
            var _b = _this.state, colorObject = _b.colorObject, alpha = _b.alpha, hexForShow = _b.hexForShow;
            var classes = classNames(prefixCls, className);
            var controllerCls = classNames(prefixCls + "-controller");
            var slidesCls = classNames(controllerCls + "-slides");
            var inputsCls = classNames(prefixCls + "-inputs");
            return (h("div", tslib_1.__assign({}, rest, { className: classes, style: tslib_1.__assign({}, style) }),
                _this.renderColorMap(classNames),
                h("div", { className: controllerCls },
                    _this.renderEyeDropper(classNames, controllerCls),
                    h("div", { className: slidesCls, ref: _this.colorBarRef },
                        _this.renderHueBar(classNames, slidesCls),
                        _this.renderAlphaBar(classNames, slidesCls)),
                    _this.renderPreview(classNames, controllerCls)),
                h("div", { className: inputsCls },
                    _this.renderColorInput({
                        classNames: classNames,
                        parentClassName: inputsCls,
                        cellName: 'hex',
                        value: hexForShow.replace('#', ''),
                        onChange: _this.handleHexInput
                    }),
                    _this.renderColorInput({
                        classNames: classNames,
                        parentClassName: inputsCls,
                        cellName: 'r',
                        value: Math.round(colorObject.rgb.r),
                        onChange: function (red) { _this.handleRGBInput(_this.correctNumberInput(red)); }
                    }),
                    _this.renderColorInput({
                        classNames: classNames,
                        parentClassName: inputsCls,
                        cellName: 'g',
                        value: Math.round(colorObject.rgb.g),
                        onChange: function (green) { _this.handleRGBInput(undefined, _this.correctNumberInput(green)); }
                    }),
                    _this.renderColorInput({
                        classNames: classNames,
                        parentClassName: inputsCls,
                        cellName: 'b',
                        value: Math.round(colorObject.rgb.b),
                        onChange: function (blue) { _this.handleRGBInput(undefined, undefined, _this.correctNumberInput(blue)); }
                    }),
                    _this.renderColorInput({
                        classNames: classNames,
                        parentClassName: inputsCls,
                        cellName: 'a',
                        value: Math.round(alpha * 100),
                        onChange: _this.handleAlphaInput
                    })),
                children));
        };
        return _this;
    }
    Palette.prototype.recieveInitialColor = function (initialColor) {
        if (!initialColor) {
            return { initialColorObject: chromatism_1.convert('#000000'), initialAlpha: 1 };
        }
        var hexRegex = /^#([0-9A-F]{3}){1,2}$/i;
        var rgbaRegex = /^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/i;
        var colorString = initialColor.replace(' ', '');
        if (hexRegex.test(colorString)) {
            return { initialColorObject: chromatism_1.convert(colorString), initialAlpha: 1 };
        }
        var rgbaMatchArray = colorString.match(rgbaRegex);
        if (rgbaMatchArray) {
            var initialAlpha = rgbaMatchArray[4] ? parseFloat(rgbaMatchArray[4]) : 1;
            var initialColorObject = chromatism_1.convert("rgb(" + rgbaMatchArray.slice(1, 4).join(',') + ")");
            return { initialColorObject: initialColorObject, initialAlpha: initialAlpha };
        }
        try {
            return { initialColorObject: chromatism_1.convert(colorString), initialAlpha: 1 };
        }
        catch (_a) {
            return { initialColorObject: chromatism_1.convert('#000000'), initialAlpha: 1 };
        }
    };
    Palette.prototype.handleCursorMove = function (target, e) {
        switch (target) {
            case interface_1.PaletteCursorTarget.colormap:
                this.onColorChange(this.calculateColorMapResult(this.calculateColorMapRelativeRatio(e)));
                break;
            case interface_1.PaletteCursorTarget.hue:
                this.onColorChange(this.calculateHueBarResult(this.calculateColorBarRelativeRaito(e)));
                break;
            case interface_1.PaletteCursorTarget.alpha:
                this.onAlphaChange(this.calculateAlphaBarResult(this.calculateColorBarRelativeRaito(e)));
                break;
        }
    };
    Palette.prototype.handleCursorEnd = function (target, e) {
        switch (target) {
            case interface_1.PaletteCursorTarget.colormap:
                document.removeEventListener('mousemove', this.handleCursorMoveForColorMap);
                document.removeEventListener('mouseup', this.handleCursorEndForColorMap);
                break;
            case interface_1.PaletteCursorTarget.hue:
                document.removeEventListener('mousemove', this.handleCursorMoveForHue);
                document.removeEventListener('mouseup', this.handleCursorEndForHue);
                break;
            case interface_1.PaletteCursorTarget.alpha:
                document.removeEventListener('mousemove', this.handleCursorMoveForAlpha);
                document.removeEventListener('mouseup', this.handleCursorEndForAlpha);
                break;
        }
        this.handleCursorMove(target, e);
        this.onColorSelect();
    };
    Palette.prototype.correctNumberInput = function (input, min, max) {
        if (min === void 0) { min = 0; }
        if (max === void 0) { max = 255; }
        var correctedNumberInput = input || '0';
        var correctedNumber = parseInt(correctedNumberInput, 10);
        return !correctedNumber ? 0 : this.getRangedValue(min, max, correctedNumber);
    };
    Palette.prototype.componentWillUnmount = function () {
        document.removeEventListener('mousemove', this.handleCursorMoveForColorMap);
        document.removeEventListener('mouseup', this.handleCursorEndForColorMap);
        document.removeEventListener('mousemove', this.handleCursorMoveForHue);
        document.removeEventListener('mouseup', this.handleCursorEndForHue);
        document.removeEventListener('mousemove', this.handleCursorMoveForAlpha);
        document.removeEventListener('mouseup', this.handleCursorEndForAlpha);
    };
    Palette.prototype.render = function () {
        return theme_1.consumeTheme(this.themedRender);
    };
    return Palette;
}(React.Component));
exports.default = Palette;
Palette.defaultProps = {
    prefixCls: 'dui-colorpicker-palette',
    selectedColor: '#08084d',
    onColorSelect: helper_1.emptyFn,
};
